import React from 'react';
import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/firestore';
// Required for side-effects
require("firebase/firestore");

export const FirebaseContext = React.createContext(null);

// Initialize Firebase
const config = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: "event-app-90ab5",
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,

};

class Firebase {
  constructor() {
    //app.initializeApp(config);

    /* Helper */

    this.fieldValue = firebase.firestore.FieldValue;
    this.emailAuthProvider = firebase.auth.EmailAuthProvider;

    /* Firebase APIs */

    this.auth = firebase.auth();
    this.db = firebase.firestore();

    /* Social Sign In Method Provider */

    this.googleProvider = new firebase.auth.GoogleAuthProvider();
    this.facebookProvider = new firebase.auth.FacebookAuthProvider();
  }

  
  doSignInWithGoogle = () =>
    this.auth.signInWithPopup(this.googleProvider);

  doSignInWithFacebook = () =>
    this.auth.signInWithPopup(this.facebookProvider);

  doSignOut = () => this.auth.signOut();  

}
export const firebaseApp = firebase.initializeApp(config);
export const auth = firebase.auth();
export const db = firebase.firestore();

export default firebase;

//export default Firebase;



// WEBPACK FOOTER //
// ./src/components/Firebase.js